export default __webpack_public_path__ + "static/media/4am_coaching_banner_img.38dfb728.svg";